export default __webpack_public_path__ + "static/media/equipment-front-lighting.82a3e7ac.jpg";